import React, { useEffect, useState } from "react";
import { ToastMessage } from "./ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { yodaOrdersActions } from "../../logic/actions";
import config from "../../utils/globalConfig";
import { Box, Flex } from "rebass";
import { ProductImage } from "../common/ProductImage";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import { getLocalizedString } from "../../utils";
import { CgColorPicker } from "react-icons/cg";
import ColorsSideBar from "./ColorsSideBar";
import OrderInfo from "./OrderInfo";
import { Price } from "../common/Price";

const MobileOrderDetail = ({
  id,
  modelCode,
  previewImage,
  collectionCode,
  line,
  collection,
  calculatedColors,
  sortColors,
  forceVisible,
  forceColorInvisibility,
  forceVisibleFromModal,
  totalQuantityC,
  totalPriceC,
  expandAll,
  totalQuantity,
  totalPrice,
  sessionAddedColors,
}) => {
  const lang = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";

  const { order, configuration } = useSelector((state) => state.yodaOrders);
  const { catalogueItemDetails } = useSelector((state) => state.yodaCatalogue);

  const dispatch = useDispatch();

  const [deleteMessage, setDeleteMessage] = useState();
  const [colorCode, setColorCode] = useState();
  const [mModelCode, setMModelCode] = useState();
  const [showDetails, setShowDetails] = useState(false);
  const [showAllColors, setShowAllColors] = useState(false);

  useEffect(() => {
    expandAll ? setShowDetails(true) : setShowDetails(false);
  }, [expandAll]);

  return (
    <>
      <ToastMessage
        message={deleteMessage}
        needConfirm={true}
        confirmFunction={(ev) => {
          dispatch(
            yodaOrdersActions.removeProduct(
              order.id,
              config.ORDER_TYPE_REORDER,
              id,
              mModelCode,
              colorCode,
            ),
          );
          setDeleteMessage(null);
          setColorCode(null);
          setMModelCode(null);

          if (colorCode) {
            forceColorInvisibility(colorCode);
          }
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        cancelFunction={(ev) => {
          setDeleteMessage(null);
          setColorCode(null);
          setMModelCode(null);
          ev.preventDefault();
          ev.stopPropagation();
          ev.nativeEvent.stopImmediatePropagation();
        }}
        style={{ width: 600 }}
      />
      <Flex flexDirection="column">
        <Flex justifyContent="left" width="100%">
          <ProductImage
            img={previewImage}
            scale={"1.2"}
            width={"120px"}
            height={"190px"}
          ></ProductImage>
          <Flex width="calc(100% - 120px)" p="10px" flexDirection="column">
            <Flex width="100%" justifyContent="right" style={{ gap: "10px" }}>
              {showDetails ? (
                <BsChevronUp onClick={() => setShowDetails(!showDetails)} />
              ) : (
                <BsChevronDown onClick={() => setShowDetails(!showDetails)} />
              )}
              <Box bg="black">
                <IoMdClose
                  color="white"
                  onClick={(evt) => {
                    setMModelCode(modelCode);
                    setDeleteMessage(
                      getLocalizedString("DELETEORDER_ITEM_MESSAGE") +
                        modelCode +
                        " ?",
                    );
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.nativeEvent.stopImmediatePropagation();
                  }}
                />
              </Box>
            </Flex>
            <Flex flexDirection="column">
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Codice modello")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{modelCode}</span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Codice collezione")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{collectionCode}</span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Linea")}:
                </span>
                <span style={{ fontWeight: "bold" }}>
                  {configuration
                    ?.filter?.((f) => f.typeId == order?.orderTypeId)?.[0]
                    ?.configuration?.filter((f) => f.line == line)?.[0]
                    ?.lineDescription?.[lang] || ""}
                </span>
              </Box>
              <Box>
                <span style={{ marginRight: "5px" }}>
                  {getLocalizedString("Collezione")}:
                </span>
                <span style={{ fontWeight: "bold" }}>{collection}</span>
              </Box>
              <Flex
                alignItems="center"
                style={{ gap: "4px" }}
                mt="10px"
                onClick={() => setShowAllColors(!showAllColors)}
              >
                <CgColorPicker />
                <span style={{ fontSize: "14px" }}>
                  {getLocalizedString("COLORS AVAILABILITY")}
                </span>
              </Flex>
              {showAllColors && (
                <ColorsSideBar
                  colors={calculatedColors}
                  id={id}
                  onClose={() => setShowAllColors(!showAllColors)}
                  forceVisible={forceVisibleFromModal}
                  offsetTop={50}
                />
              )}
            </Flex>
          </Flex>
        </Flex>
        {showDetails && (
          <Flex m="10px" flexDirection="column">
            <Flex
              width="100%"
              justifyContent="end"
              onClick={() => setShowDetails(!showDetails)}
            ></Flex>
            {sortColors(calculatedColors).map((color, i) => (
              <Flex
                key={i}
                mb="4px"
                style={{
                  display: forceVisible[color.code] ? "" : "none",
                }}
              >
                <OrderInfo
                  id={id}
                  color={color}
                  customer={order?.customerData}
                  totalPrice={totalPriceC[color.code]}
                  totalQuantity={totalQuantityC[color.code]}
                  catalogueItems={catalogueItemDetails}
                  expandAll={expandAll}
                  modelCode={modelCode}
                  forceVisible={forceVisible}
                  type={config.ORDER_TYPE_REORDER}
                  forceColorInvisibility={(color) =>
                    forceColorInvisibility(color)
                  }
                  isLastAdded={
                    sessionAddedColors.includes(color.code) && i === 0
                  }
                />
              </Flex>
            ))}
          </Flex>
        )}
        <Flex
          px="40px"
          py="10px"
          mx="10px"
          style={{ borderTop: "1px solid #c2c2c2", gap: "8px" }}
          alignItems="center"
          justifyContent="center"
        >
          <Box px="10px" style={{ borderRight: "1px solid #c2c2c2" }}>
            <span style={{ marginRight: "8px", fontWeight: "bold" }}>
              {getLocalizedString("TOTALE")}
            </span>
            <span style={{ fontWeight: "bold" }}>{totalQuantity || 0}</span>
          </Box>
          <Price style={{ fontWeight: "bold" }} price={totalPrice}></Price>
        </Flex>
      </Flex>
    </>
  );
};

export default MobileOrderDetail;
